module.exports = __webpack_public_path__ + "static/img/style_2.03b717a5.png";